import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { Grid } from "@mui/material";
import DrawerCM from "components/shared/Drawer";
import Toast from "helper/toast";
import LoadingCM from "components/shared/Loading";
import useHttp from "hooks/use-http";
import StackCm from "components/shared/StackCm";
import { StyledGlBtn } from "styles/globals";
import TextFieldCm from "components/shared/TextField";
import { useState } from "react";
import EditorCm from "components/shared/EditorCm";
import Upload from "components/shared/Upload";
import { validateImg } from "validations";
import { useCallback } from "react";
import { getAboutUsRequest, updateAboutUsRequest } from "api/aboutUs";
import { useEffect } from "react";
import { aboutUsSchema } from "validations/aboutUs";
import ProgressBarCM from "components/shared/ProgressBar";
import { IMG_BASE_URL } from "constants";

export default function AddAbout() {
  const { request, loading, isUploading, setUploadProgress, uploadProgress } =
    useHttp(false);

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({ resolver: yupResolver(aboutUsSchema) });

  // editor value
  const [text, setText] = useState("");

  // IMAGE
  const [image, setImage] = useState({
    url: null,
    isChanged: false,
  });

  // uploaded image handler method
  const handleChangeImage = (val) => {
    const isValid = validateImg(val);
    isValid && setImage({ url: val, isChanged: true, isWeb: false });
  };

  const onSubmit = async (data) => {
    const res = await request({
      url: () =>
        updateAboutUsRequest(
          {
            ...data,
            image: image.isWeb ? null : image.url,
            description: text,
          },
          (progress) => setUploadProgress(progress)
        ),
      isFile: true,
    });
    if (res) {
      Toast({ type: "success" });
      reset();
      getAboutUs();
    }
  };

  const getAboutUs = useCallback(async () => {
    const res = await request({
      url: getAboutUsRequest,
    });
    if (res) {
      reset({
        title: res.title || "",
        alt: res.image.alt || "",
      });
      setText(res.description || "");
      setImage({
        isChanged: Boolean(res?.image.url),
        url: res?.image.url || null,
        isWeb: true,
      });
    }
  }, []);

  useEffect(() => {
    getAboutUs();
  }, [getAboutUs]);

  return (
    <DrawerCM title="درباره ما">
      {isUploading ? (
        <ProgressBarCM value={uploadProgress} />
      ) : loading ? (
        <LoadingCM />
      ) : (
        <Grid container>
          <StackCm title="درباره ما">
            <Grid container>
              <Grid item lg={4} sm={6} xs={12} p={1.5}>
                <TextFieldCm
                  label="عنوان"
                  id="title"
                  register={register}
                  errors={errors}
                />
              </Grid>
              <Grid item lg={4} sm={6} xs={12} p={1.5}>
                <TextFieldCm
                  label="متن جایگزین (alt)"
                  id="alt"
                  register={register}
                  errors={errors}
                />
              </Grid>
              <Grid item lg={4} xs={12} p={1.5}>
                <>
                  {image.url ? (
                    <Upload
                      isWeb={image.isWeb}
                      isLocal={!image.isWeb}
                      file={image.url}
                      refillable
                      type="add-image"
                      onChange={handleChangeImage}
                      width={"100%"}
                      height={"100%"}
                      objectFit="contain"
                    />
                  ) : (
                    <Upload
                      isLocal={image.isChanged}
                      file={image.url}
                      refillable
                      type="add-image"
                      onChange={handleChangeImage}
                      width={"100%"}
                      height={"100%"}
                      objectFit="contain"
                    />
                  )}
                </>
              </Grid>
            </Grid>
            <Grid item xs={12} p={1.5}>
              <EditorCm state={text} setState={setText} />
            </Grid>
            <StyledGlBtn
              onClick={handleSubmit(onSubmit)}
              color={"success"}
              title="ثبت"
            />
          </StackCm>
        </Grid>
      )}
    </DrawerCM>
  );
}
